import { render, staticRenderFns } from "./PinnedBlogs.vue?vue&type=template&id=6a75e7d8"
import script from "./PinnedBlogs.vue?vue&type=script&setup=true&lang=ts"
export * from "./PinnedBlogs.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports